// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-menu {
  line-height: initial;
  display: block;
  position: absolute;
  z-index: 999;
  top: 63px;
  right: 2%;
  border: none;
  width: 20%;
  font-size: 10px;
  font-weight: bold;
  background: #FFFFFF;
  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.0632102);
  border-radius: 2px;
  overflow-x: hidden;
}

.notification-menu .list-group {
  border: none;
}

@media (max-width: 1199px) {
  .notification-menu {
    width: 25%;
  }
}
.tab-title {
  display: inline-block;
  padding: 0 !important;
  width: 20% !important;
}

.tab-title .btn {
  font-size: 10px !important;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  color: #7e8094;
  width: 100% !important;
  text-decoration: none !important;
}

.active .btn {
  color: var(--theme-main-color, #055C8D);
}

.tab-title button:focus {
  outline: 0px !important;
  -webkit-appearance: none;
  box-shadow: none !important;
}

.tab-header {
  border-bottom: 1px solid rgba(105, 105, 105, 0.125);
}

.newMessage {
  font-weight: bolder;
}

.oldMessage {
  font-weight: normal;
}

.no-data {
  padding-top: 15px;
  padding-bottom: 15px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
